import axios from '@/plugins/axios'
import { MessageBox, Message } from 'element-ui'

export default {
  namespaced: true,

  state: {
    loading: false,
    shorts: [],
    page: 1,
    page_size: 10,
    order_column: 'created_at',
    order_type: 'desc',
    wheres: [
      'Beginning',
      'First Half',
      'Middle',
      'End',
      'Whole video',
      'Nothing'
    ],
    credits: ['Shout-Out', 'Video Overlay', 'Nothing']
  },

  mutations: {
    setShorts(state, payload) {
      state.shorts = payload
    },
    setPageShorts(state, payload) {
      state.page = payload
    },
    setPageSize(state, payload) {
      state.page_size = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    }
  },

  actions: {
    readShorts({ commit, state }, filters = null) {
      commit('setLoading', true)

      let ls = localStorage.getItem('video_track_scan_filter')
      filters = JSON.parse(ls)

      axios.admin
        .get('vc/video-tracks-scan', {
          params: {
            page: state.page,
            page_size: state.page_size,
            order_column: state.order_column,
            order_type: state.order_type,
            video_type: 2,
            ...filters
          }
        })
        .then(r => {
          commit('setShorts', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    update({ dispatch }, payload) {
      axios.admin
        .post(`vc/video-tracks-scan`, {
          ...payload
        })
        .then(() => {
          dispatch('readShorts')
        })
    },
    approve({ dispatch }, payload) {
      Object.assign(payload, {
        video_approved: 1
      })
      axios.admin
        .post(`vc/video-tracks-scan`, {
          ...payload
        })
        .then(() => {
          dispatch('readShorts')
        })
    },
    reject({ dispatch }, payload) {
      Object.assign(payload, {
        video_approved: 0
      })
      MessageBox.confirm(`You will return VidCents. Continue?`, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(() => {
        axios.admin
          .post(`vc/video-tracks-scan`, {
            ...payload
          })
          .then(() => {
            Message({
              type: 'success',
              message: 'VidCents returned'
            })
            dispatch('readShorts')
          })
          .catch(() => {
            Message({
              type: 'info',
              message: 'VidCents return cancelled'
            })
          })
      })
    }
  }
}
